import axios from 'axios';
import { toast } from 'react-toastify';

export function multiCourseUsers(courseIds, searchTerm) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/multiCourseReports/multiCourseUsers', {
          courseIds,
          searchTerm,
        })
        .then((response) => {
          const data = response.data.courseUsers;

          return resolve(data);
        })
        .catch((error) => {
          toast('Error while getting course users. Please try again.', {
            type: 'error',
          });

          return resolve();
        });
    });
  };
}

export function multiCourseStudentsReportByTopic(courseId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/multiCourseReports/multiCourseStudentsReportByTopic', {
          courseId,
        })
        .then((response) => {
          const data = response.data.studentsReportByTopic;

          return resolve(data);
        })
        .catch((error) => {
          toast('Error while getting report by topic. Please try again.', {
            type: 'error',
          });

          return resolve();
        });
    });
  };
}

export function multiCourseStudentsReportByWeek(courseIds, reportType) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/multiCourseReports/multiCourseStudentsReportByWeek', {
          courseIds,
          reportType,
        })
        .then((response) => {
          const data = response.data.studentsReportByWeek;

          return resolve(data);
        })
        .catch((error) => {
          toast('Error while getting report by week. Please try again.', {
            type: 'error',
          });

          return resolve();
        });
    });
  };
}

export function refreshMultiCourseReport(report) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/multiCourseReports/refreshMultiCourseReport', {
          report,
        })
        .then((response) => {
          toast(
            'We are regenerating this report. We will email you when it’s ready.',
            {
              type: 'success',
            },
          );

          return resolve();
        })
        .catch((error) => {
          toast('Error while refreshing report. Please try again.', {
            type: 'error',
          });

          return resolve();
        });
    });
  };
}
